import { render, staticRenderFns } from "./NhomPhanHoiForm.vue?vue&type=template&id=2b001413&"
import script from "./NhomPhanHoiForm.vue?vue&type=script&lang=js&"
export * from "./NhomPhanHoiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports